import React from "react";
import { Home, BarChart, User } from "lucide-react"; // minimalist icons
import "./BottomNav.css";

const BottomNav = ({ activeTab, onTabChange }) => {
  const tabs = [
    { id: "analytics", icon: <BarChart /> },
    { id: "dashboard", icon: <Home /> },
    { id: "profile", icon: <User /> },
  ];

  return (
    <nav className="bottom-nav">
      {tabs.map((tab) => (
        <div
          key={tab.id}
          className={`nav-item ${activeTab === tab.id ? "active" : ""}`}
          onClick={() => onTabChange(tab.id)}
        >
          {React.cloneElement(tab.icon, {
            size: 24,
            color: activeTab === tab.id ? "#fff" : "#000", // white when active, black when inactive
          })}
        </div>
      ))}
    </nav>
  );
};

export default BottomNav;



